import type { Document } from '@kanda-libs/ks-frontend-services';

export const formatImage = (image: Document): string | undefined => {
  const prefix = `data:${image.mimetype || 'image/png'};base64,`;
  const { content } = image;
  if (!content) return undefined;
  return `${prefix}${image.content}`;
};
